import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'

export interface SimpleCollection {
  id: number
  collectionNo: string
  bibliographyRealId: number
  displayTitle: string
  collectionStatus: SystemCode
  holdingBranchCode: SystemCode
  handlingType: SystemCode
  acceptDate: string
  lendUserId: string
  revision: number
}

export function SimpleCollectionFromJSON(json: any): SimpleCollection {
  return {
    id: exists(json, 'id') ? json.id : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    collectionStatus: exists(json, 'collection_status')
      ? SystemCodeFromJSON(json.collection_status)
      : defaultSystemCode(),
    holdingBranchCode: exists(json, 'holding_branch_code')
      ? SystemCodeFromJSON(json.holding_branch_code)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    acceptDate: exists(json, 'accept_date')
      ? dateToPlainFormat(json.accept_date)
      : '',
    lendUserId: exists(json, 'lend_user_id') ? json.lend_user_id : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
